<template>
  <router-view/>
</template>

<script>
export default {
  name: 'Maestro'
}
</script>

<style scoped>

</style>